module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "isotopeGrid"
  }, [_c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title_wrapper"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.isotopeProps.title) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subTitle"
  }, [_vm._v("\n        " + _vm._s(_vm.isotopeProps.desc) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_c('div', {
    staticClass: "isotopeWrapper"
  }, [(_vm.isotopeProps.showTag) ? _c('div', {
    staticClass: "tags"
  }, [_c('div', {
    staticClass: "button-group"
  }, _vm._l((_vm.isotopeProps.option.getFilterData), function(val, key) {
    return _c('button', {
      staticClass: "button",
      class: [key === _vm.isotopeProps.filterOption ? 'is-checked' : ''],
      on: {
        "click": function($event) {
          _vm.filter(key)
        }
      }
    }, [_vm._v(_vm._s(key) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isotopeProps.popup) ? _c('isotope', {
    ref: "ist",
    staticClass: "isoDefault",
    attrs: {
      "list": _vm.isotopeProps.list,
      "id": "root_isotope",
      "options": _vm.isotopeProps.option
    }
  }, _vm._l((_vm.isotopeProps.list), function(element) {
    return _c('div', {
      key: element.id,
      on: {
        "click": function($event) {
          _vm.showPopup(element.html)
        }
      }
    }, [(!!element.imgpath) ? _c('picture', {
      staticClass: "visual"
    }, [_c('img', {
      attrs: {
        "src": element.imgpath
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item_container"
    }, [(element.cardname) ? _c('h1', [_c('strong', [_vm._v(_vm._s(element.cardname))])]) : _c('h1', [_c('strong', [_vm._v(_vm._s(_vm.isotopeProps.cardname))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(element.name))])])])
  })) : _c('isotope', {
    ref: "ist",
    staticClass: "isoDefault",
    attrs: {
      "list": _vm.isotopeProps.list,
      "id": "root_isotope",
      "options": _vm.isotopeProps.option
    }
  }, _vm._l((_vm.isotopeProps.list), function(element) {
    return _c('router-link', {
      key: element.id,
      attrs: {
        "to": element.link
      },
      on: {
        "click": function($event) {
          _vm.isotopeProps.selected = element
        }
      }
    }, [(!!element.imgpath) ? _c('picture', {
      staticClass: "visual"
    }, [_c('img', {
      attrs: {
        "src": element.imgpath
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item_container"
    }, [(element.cardname) ? _c('h1', [_c('strong', [_vm._v(_vm._s(element.cardname))])]) : _c('h1', [_c('strong', [_vm._v(_vm._s(_vm.isotopeProps.cardname))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(element.name))])])])
  }))], 1)]), _vm._v(" "), (_vm.isotopeProps.popup) ? _c('div', {
    staticClass: "isotopePopup",
    class: {
      active: _vm.isotopeProps.openPopup
    }
  }, [_c('div', {
    staticClass: "popupWrapper"
  }, [_c('div', {
    staticClass: "popupInner"
  }, [_c('div', {
    staticClass: "closeBtn"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/cross@2x.png")
    },
    on: {
      "click": function($event) {
        _vm.togglePopup()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "popupContents",
    domProps: {
      "innerHTML": _vm._s(_vm.isotopeProps.popupContents)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "popupBG",
    on: {
      "click": function($event) {
        _vm.togglePopup()
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4268662","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/isotopeGrid/isotopeGrid.vue
// module id = 248
// module chunks = 0